// import { configureStore } from '@reduxjs/toolkit'
// import formSlice from './Slice/formSlice'
// import authReducer from './Slice/authSlice'
// import configReducer from './Slice/configSlice'
// import { thunk } from 'redux-thunk';
// import { persistReducer, persistStore } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import bookingReducer from "./Slice/bookingSlice";
// import carReducer from "./Slice/carSlice";
// const persistConfig = {
//   key: 'root',
//   storage,
// }

// const persistedForm = persistReducer(persistConfig, formSlice)
// const persistedAuth = persistReducer(persistConfig, authReducer)
// const persistedConfig = persistReducer(persistConfig, configReducer)

// export const store = configureStore({
//   reducer: {
//     // form: persistedForm,
//     // auth: persistedAuth,
//     // // config: persistedConfig,
//     // middleware: [thunk],
//     form: formSlice,
//     auth: authReducer,
//     config: configReducer,
//     booking: bookingReducer,
//     car: carReducer,

//   },

// })

// export const persistor = persistStore(store)

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import formSlice from "./Slice/formSlice";
import authReducer from "./Slice/authSlice";
import configReducer from "./Slice/configSlice";
import bookingReducer from "./Slice/bookingSlice";
import carReducer from "./Slice/carSlice";
let secretKey = process.env.REACT_APP_SECRET_KEY;

// Create an encryption transform
const encryptor = encryptTransform({
  secretKey: secretKey,
  onError: (error) => {
    // Handle the error here
    console.error(error);
  },
});

const persistConfig = {
  key: "root",
  storage,
  transforms: [encryptor], // Add the encryption transform to the persist config
};

const rootReducer = combineReducers({
  form: formSlice,
  auth: authReducer,
  config: configReducer,
  booking: bookingReducer,
  car: carReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

export const persistor = persistStore(store);
